/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { Typography2 } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import Pill from 'bundles/unified-common/components/pill/Pill';

const styles = {
  pill: css`
    display: flex;
    white-space: nowrap;
    background-color: var(--cds-color-neutral-background-primary) !important;
    border: 1px solid var(--cds-color-grey-50) !important;
    gap: var(--cds-spacing-100) !important;
    transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
    transform: translateZ(0);

    &:hover {
      box-shadow: 0 0 8px -4px rgb(0 0 0 / 32%), 0 0 8px -6px rgb(0 0 0 / 32%);
      transform: scale3d(1.01, 1.01, 1.01) translate3d(1px, -2px, 16px);
      text-decoration: none;
      color: var(--cds-color-neutral-primary) !important;
      border: 1px solid var(--cds-color-neutral-stroke-primary-weak) !important;
    }
  `,
  logo: css`
    object-fit: contain;
  `,
};

type PartnerLogoProps = {
  name: string;
  logo: string;
  href: string;
};

/**
 * Returns a clickable Pill component, displaying a partner logo and name.
 */
const PartnerLogo = ({ name, logo, href }: PartnerLogoProps) => {
  const track = useTracker();

  const handleClick = () => {
    track('click_button', {
      button: {
        name: 'partner_logo',
        linkName: 'partner_logo_link',
        linkURL: href,
        linkType: 'internal',
      },
      pageSection: {
        sectionName: 'partner_logo_list',
      },
    });
  };

  return (
    <Pill href={href} css={styles.pill} onClick={handleClick}>
      <Imgix src={logo} alt="" width={24} height={24} css={styles.logo} />
      <Typography2 variant="subtitleSmall" component="span">
        {name}
      </Typography2>
    </Pill>
  );
};

export default PartnerLogo;
